export const API_CALL_TOKBOX_URL = {
  START_VIDEORECORDING: {
    path: '/archive/start',
    params: {
      API_KEY: {
        key: 'API_KEY',
        value: ''
      }
    }
  },
  STOP_RECORDING: {
    path: '/archive/stop/{archiveId}',
    params: {
      API_KEY: {
        key: 'API_KEY',
        value: ''
      },
      archiveId: {
        key: 'archiveId',
        value: ''
      }
    }
  },
  LIST_ARCHIVES: {
    path: '/archive/{sessionId}',
    params: {
      sessionId: {
        key: 'sessionId',
        value: ''
      }
    }
  },
  DELETE_RECORDING: {
    path: '/archive/{archiveId}',
    params: {
      archiveId: {
        key: 'archiveId',
        value: ''
      }
    }
  }
};
